module Meevo.Plugins.Client {
    import SettingsDto = Meevo.Model.SettingsDto;
    "use strict";

    /**
    * New Visit Notes Section of Client Profile
    */
    export class NewDocsAndFormsSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Client> {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected contextParams: Meevo.ContextParamsService,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string,
            protected translateService?: angular.translate.ITranslateService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, identityService, noun, appSettings, sectionSecurityKey, translateService);
            this.isInteropContext = true;
        }

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:client', isInterop: true, targetRoute: `client/${this.getParentItemId()}/docs-and-forms-list` });
        }

    }
}